var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.996,
    height: 13.426,
    viewBox: "0 0 16.996 13.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_1_",
    "data-name": "mail (1)",
    transform: "translate(-0.955 -3.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_552",
    "data-name": "Path 552",
    d: "M3.491,4H15.417a1.5,1.5,0,0,1,1.491,1.491v8.944a1.5,1.5,0,0,1-1.491,1.491H3.491A1.5,1.5,0,0,1,2,14.435V5.491A1.5,1.5,0,0,1,3.491,4Z",
    fill: "none",
    stroke: "#2f67ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_553",
    "data-name": "Path 553",
    d: "M16.907,6,9.454,11.218,2,6",
    transform: "translate(0 -0.509)",
    fill: "none",
    stroke: "#2f67ed",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendEmailIcon);
export default __webpack_public_path__ + "static/media/send-email-icon.f1c08a385874ac781c19167e97b73d4a.svg";
export { ForwardRef as ReactComponent };